import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  breakfastPage,
  schedulePage,
  getOnboardingSkip,
} from '../../utils';
import '../entertainment/Entertainment.scss';
import ArrivalTimeOptions from '../arrivalTimeOptions/ArrivalTimeOptions';

const ArrivalTime = ({
  title,
  subTitle,
  isArrivalTimeEditable = false,
  arrivalTimeSlots,
  selectedArrivalSlotId,
  bookedArrivalSlotId,
  shouldFetchAvailableArrivalTimeSlots = false,
  shouldRedirectToNextPage = false,
  getAvailableArrivalTimeSlots,
  setSelectedArrivalTime,
  addArrivalTimeSlotToBooking,
  removeArrivalTimeSlotFromBooking,
  setArrivalPageWasBooked,
  refreshTimeInterval,
  lastConfigCheckDateTime,
  isShorexEnhancementEnabled,
}) => {
  const history = useHistory();
  const skipOnBoarding = getOnboardingSkip();

  useEffect(() => {
    if (shouldRedirectToNextPage) {
      setArrivalPageWasBooked(false);
      if (skipOnBoarding) {
        history.push(schedulePage);
        return;
      }
      history.push(breakfastPage);
    }
  }, [
    skipOnBoarding,
    shouldRedirectToNextPage,
    history,
    setArrivalPageWasBooked,
    selectedArrivalSlotId,
  ]);

  useEffect(() => {
    if (shouldFetchAvailableArrivalTimeSlots) {
      getAvailableArrivalTimeSlots();
    }
  }, [shouldFetchAvailableArrivalTimeSlots, getAvailableArrivalTimeSlots]);

  return (
    <div>
      <div className="entertainment-main-container notSummaryPage">
        <div className="titles">
          <div className="title">{title}</div>
          <div className="sub-title">{subTitle}</div>
        </div>
        <div className="arrival-time-explanation">
          Access to accommodation is 3pm for Premium accommodation and 4pm for all others, if a later arrival time is selected your room will be ready at the later time.
        </div>
        <div className="entertainments notSummaryPage">
          <ArrivalTimeOptions
            title={title}
            options={arrivalTimeSlots}
            quantityToBook={1}
            setSelectedArrivalTime={setSelectedArrivalTime}
            selectedArrivalSlotId={selectedArrivalSlotId}
            bookedArrivalSlotId={bookedArrivalSlotId}
            addArrivalTimeSlotToBooking={addArrivalTimeSlotToBooking}
            isArrivalTimeEditable={isArrivalTimeEditable}
            removeArrivalTimeSlotFromBooking={removeArrivalTimeSlotFromBooking}
            refreshTimeInterval={refreshTimeInterval}
            lastConfigCheckDateTime={lastConfigCheckDateTime}
            getAvailableArrivalTimeSlots={getAvailableArrivalTimeSlots}
            isShorexEnhancementEnabled={isShorexEnhancementEnabled}
          />
        </div>
      </div>
    </div>
  );
};

ArrivalTime.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  getAvailableArrivalTimeSlots: PropTypes.func,
  isArrivalTimeEditable: PropTypes.bool,
  arrivalTimeSlots: PropTypes.array,
  selectedArrivalSlotId: PropTypes.number,
  shouldFetchAvailableArrivalTimeSlots: PropTypes.bool,
  setSelectedArrivalTime: PropTypes.func,
  addArrivalTimeSlotToBooking: PropTypes.func,
  removeArrivalTimeSlotFromBooking: PropTypes.func,
  shouldRedirectToNextPage: PropTypes.bool,
  setArrivalPageWasBooked: PropTypes.func,
  bookedArrivalSlotId: PropTypes.number,
  refreshTimeInterval: PropTypes.number,
  lastConfigCheckDateTime: PropTypes.string,
  isShorexEnhancementEnabled: PropTypes.bool,
};

export default ArrivalTime;
